import type { Model } from '@shady-pines/db';
import type { Uuid } from '@shady-pines/types';
import { isNil } from 'lodash';
import { useEffect } from 'react';
import { useGlobalContextStore } from './global-context/global-context-store';

export const useRefreshEntity = <T extends Model>(
  type: 'show' | 'event' | 'eventVenue',
  refreshFunction: () => Promise<
    | undefined
    | {
        result: 'refreshed' | 'no-refresh-required' | 'full-refresh-needed';
        refreshedIds?: Uuid<T>[];
      }
  >,
  fetchFunction: () => Promise<void>,
) => {
  const refreshInterval = useGlobalContextStore(
    (s) => s.getConfiguration('refresh_entities_interval_minutes')?.parameter_number,
  );

  useEffect(() => {
    if (isNil(refreshInterval)) {
      return;
    }

    const interval = setInterval(() => {
      const runShowRefresh = async () => {
        const refreshResult = await refreshFunction();
        if (refreshResult?.result === 'refreshed') {
          console.log('refreshed entity!', type, refreshResult);
        }
        if (refreshResult?.result === 'full-refresh-needed') {
          console.log('full refresh required, refreshing', type);
          await fetchFunction();
        }
      };

      void runShowRefresh();
    }, 60_000 * refreshInterval);

    return () => clearInterval(interval);
  }, [fetchFunction, refreshFunction, refreshInterval, type]);
};
